<template>
  <v-card
    width="250"
    ripple
    @mouseenter.native="handleMouseenter"
    @mouseleave.native="handleMouseleave"
    class="private-thought-card"
  >
    <v-row style="margin: 0">
      <v-col style="padding: 0" class="private-thought-leftcol" v-if="isHovered">
        <v-list-item @click.native="makeThoughtPublic">
          <v-list-item-content>
            <v-list-item-title style="white-space: normal">
              Make Public
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-col>
      <v-col style="padding: 0" class="private-thought-rightcol" v-if="isHovered">
        <v-list-item @click.native="moveToParkingLot">
          <v-list-item-content>
            <v-list-item-title style="white-space: normal">
              Move To Parking Lot
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-col>
      <v-col style="padding: 0" v-if="!isHovered">
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title style="white-space: normal">
              {{ thought.content }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'Thought',
  props: ['thought'],
  data: () => ({
    isHovered: false
  }),

  methods: {
    ...mapActions('canvas', ['requestMakeThoughtPublic', 'moveThoughtToParkingLot']),
    handleMouseenter () {
      this.isHovered = true
    },
    handleMouseleave () {
      this.isHovered = false
    },
    makeThoughtPublic () {
      this.requestMakeThoughtPublic(this.thought)
    },
    moveToParkingLot () {
      this.moveThoughtToParkingLot(this.thought)
    }
  }
}
</script>

<style lang="sass" scoped>
  .private-thought-card
    margin: 1em
    touch-action: none
    background-image: linear-gradient(120deg, rgba(255, 149, 24, 0.9), rgba(255,149,24,0.4))

  .private-thought-leftcol:hover
    background-color: rgba(255, 255, 255, 0.2)
    cursor: pointer
    border-top-left-radius: 5px
    border-bottom-left-radius: 5px

  .private-thought-rightcol:hover
    background-color: rgba(255, 255, 255, 0.2)
    cursor: pointer
    border-top-right-radius: 5px
    border-bottom-right-radius: 5px
</style>
